module.exports = __webpack_public_path__ + "static/img/academy-module.a42d0e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/academy-module.png
// module id = 5Q0m
// module chunks = 1